const NoRegistratedAlert = () => {
  return (
    <div className="card mb-4 student-not-enrolled-card">
      <div className="student-not-enrolled-strip" />
      <div className="card-body text-center py-5">
        <div className="mb-3 d-flex justify-content-center">
          <div className="student-not-enrolled-icon-wrap">
            <i className="ti ti-alert-triangle text-warning student-icon-alert" />
          </div>
        </div>

        <h5 className="text-warning mb-2 fw-bold">Étudiant non inscrit</h5>
        <p className="text-muted mb-4 student-not-enrolled-text">
          L'étudiant sélectionné n'est pas inscrit pour l'année sélectionnée.
          <br />
          Veuillez vérifier l'année ou contacter la scolarité pour plus
          d'informations.
        </p>

        <div className="d-flex justify-content-center gap-2 flex-wrap">
          <span className="badge bg-warning-subtle text-warning px-3 py-2 student-not-enrolled-pill">
            <i className="ti ti-info-circle me-1" />
            Vérifiez l'inscription
          </span>
        </div>
      </div>
    </div>
  );
};

export default NoRegistratedAlert;
